export default Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 1
});